import { inject, Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router } from '@angular/router';

import { Observable, tap } from 'rxjs';

import { AppRoutePath } from '@cdba/app-route-path.enum';
import { EmptyStatesPath } from '@cdba/core/empty-states/empty-states-path.enum';
import { BetaFeatureService } from '@cdba/shared/services/beta-feature/beta-feature.service';

@Injectable({
  providedIn: 'root',
})
export class BetaFeatureRoleGuard implements CanActivate {
  private readonly router = inject(Router);
  private readonly betaFeatureService = inject(BetaFeatureService);

  canActivate(childRoute: ActivatedRouteSnapshot): Observable<boolean> {
    return this.betaFeatureService
      .canAccessBetaFeature$(childRoute.data['betaFeature'])
      .pipe(
        tap((canActivate: boolean) => {
          if (!canActivate) {
            this.router.navigate([
              AppRoutePath.EmptyStatesPath,
              EmptyStatesPath.ForbiddenPath,
            ]);
          }
        })
      );
  }
}
